import { render, staticRenderFns } from "./Audience_form.vue?vue&type=template&id=067ff3c5&"
import script from "./Audience_form.vue?vue&type=script&lang=js&"
export * from "./Audience_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports